import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse,
} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(public auth: AuthService, private router: Router) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    const token = localStorage.getItem('token');
    let state = '';

    if (request.url.includes(environment.url)) {
      state = sessionStorage.getItem('state');
    }

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        State: `${state}`,
      },
      withCredentials: true,
    });

    if (request.method !== 'GET' && request.url.includes(environment.people_url) && localStorage.getItem('csrf_token') !== 'null') {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          'Acesso-Csrf-Token': localStorage.getItem('csrf_token')
        },
        withCredentials: true
      })
    }

    return next.handle(request).pipe(
      map((res) => {
        if (res instanceof HttpResponse && res?.headers?.keys().includes('acesso-csrf-token')) {
          const csrf_token = res?.headers.get('acesso-csrf-token');
          localStorage.setItem('csrf_token', csrf_token);
        }
        return res
      }),
      catchError((error: HttpErrorResponse) => {
        if ((error?.status === 401 || error?.status === 500) && request.url.includes(environment.url)) {
          localStorage.removeItem('token')
          this.auth.redirectLogout();
        }
        return throwError(error);
      })
    );
  }
}
